<template>
    <div>
        <el-card>
            <el-row>
                <el-col :span="24">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: '/KPI/Index' }">绩效管理</el-breadcrumb-item>
                        <el-breadcrumb-item>查看KPI结果</el-breadcrumb-item>
                    </el-breadcrumb>
                </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row>
                <!-- :class="currentRole.Key=='director'?'show':'hidden'" -->
                <el-col :span="20"  style="text-align:right;" :class="currentRole.Key=='director'?'show':'hidden'">
                <el-button size="mini" type="primary" plain @click="LookKPI">KPI评分</el-button>
                </el-col>
                <!-- :class="currentRole.Key=='director'?(isShowSend?'show':'hidden'):'hidden'" -->
                <el-col :span="4" style="text-align:right;" :class="currentRole.Key=='director'?(isShowSend?'show':'hidden'):'hidden'" >
                <el-button size="mini" :disabled="disabledMonth"  type="success" plain @click="sendMonth" >发送月度KPI</el-button>
                <el-button size="mini" :disabled="disabledJD"  type="warning" plain @click="sendJuDu" >发送季度KPI</el-button>
                </el-col>
            </el-row>
            <el-tabs v-model="activeName">
                <el-tab-pane label="月度" name="month">
                    <LookKPIResultList :pt="0"></LookKPIResultList>
                </el-tab-pane>
                <el-tab-pane label="季度" name="quarter">
                    <LookKPIResultList :pt="1"></LookKPIResultList>
                </el-tab-pane>
            </el-tabs>
        </el-card>
    </div>
</template>
<script>
import LookKPIResultList from "../KPI/LookKPIResultList";
import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic"; 
import { SendFrameResult,MyUserKpi } from "../../until/ZeusApiSDK/Logic/KPILogic";
export default {
  data() {
    return {
      activeName: "month",
      isShowSend:false,//是否显示发送按钮
        currentRole:{},//当前用户角色
        currentUser:{},//获取当前用户
        disabledMonth:true,
        disabledJD:true,//是否显示发送按钮
        year:'',//选择年
        month:'',//选择月
        deptModel:{},//当前操作部门
    };
  },
  components: {
    LookKPIResultList
  },
  created() {
        //获取当前用户
        this.getCurrentUser();
   
     //获取当前用户角色
    this.getCurrentRole();
    
        //获取当前操作部门
        this.getCurrentDept();
    // console.log(this.currentRole);
    this.centerHead();

    
        var date=new Date();
        this.year=date.getFullYear();
        this.month=date.getMonth();
        // console.log("month="+ this.month);
        if(this.month==0){
            //如果上个月是12月，则年份减1为上个月
            this.year=this.year-1;
        }

    //获取是否显示
    this.MyUserKpi();
        // console.log("year="+ this.year);
  },
  methods: {
        //获取当前用户
        getCurrentUser:function(){
            var userinfo = window.sessionStorage.getItem("userinfo");
            userinfo = JSON.parse(Decrypt(userinfo));
            this.currentUser = userinfo;
        },
    //获取当前用户角色
    getCurrentRole:function(){
        var currentUserRole = window.sessionStorage.getItem("CurrentUserRole");
        this.currentRole = JSON.parse(Decrypt(currentUserRole));
        
        if(this.currentRole.Key=='director'){
          this.isShowSend=true;
          this.disabledMonth=false;
          this.disabledJD=false;
        }
        else{
          this.isShowSend=false;
          this.disabledMonth=true;
          this.disabledJD=true;
        }
        
    },
    centerHead:function(){
        if(this.currentRole.RoleName=="中心负责人"||this.currentRole.RoleName=="CEO"){
            this.activeName="quarter";
        }
    },
    
    //判断当前是否已经发送
    MyUserKpi:function(){
        //获取操作周期
        
        this.month=new Date().getMonth();
            this.month=this.month+1;
            
        var jidu='Q4';
            //季度时 选择当前季度
            if(this.month>=1&&this.month<=3){
                jidu='Q4';
            }
            else if(this.month>=4&&this.month<=6){
                jidu='Q1';
            }
            else if(this.month>=7&&this.month<=9){
               jidu='Q2';
            }
            else{
                jidu='Q3';
            }
        //获取上个季度数据
            if(this.month=1){
                this.month=12;
            }
        //月度是否已经发送  
        MyUserKpi(this.month,this.year,this.deptModel.value,0,this.currentRole.Key,this.currentUser.UserCode).then(res=>{
          
            if(res.result==0){
                this.disabledMonth=true;
            }
            else{
                this.disabledMonth=false;
            }
        });
        //季度  当前季度
        
            
        //季度是否已经发送  
        MyUserKpi(jidu,this.year,this.deptModel.value,1,this.currentRole.Key,this.currentUser.UserCode).then(res=>{
           
            if(res.result==0){
                this.disabledJD=true;
            }
            else{
                this.disabledJD=false;
            }
        });
    },
        //获取当前操作部门
        getCurrentDept:function(){
            var deptModelStory = window.sessionStorage.getItem("deptModel");
            if(deptModelStory==''||deptModelStory==null||deptModelStory=='undefined'){
                GetChargeDeptsByUserCode(this.currentUser.UserCode).then(res => {
                    if (res.list.length > 0) {
                        var dept={
                            value: res.list[0].Id,
                            label: res.list[0].ClassName
                        }
                        //将加密后的操作部门保存到session中
                        window.sessionStorage.setItem(
                            "deptModel",
                            Encrypt(JSON.stringify(dept))
                        );
                        this.deptModel=dept;
                        deptModelStory = window.sessionStorage.getItem("deptModel");
                    }
                });
            }
            this.deptModel=JSON.parse(Decrypt(deptModelStory));
        },
    //查看中心KPI
    LookKPI:function(){
      window.location.href="/KPI/KPIScore";
    },
    //发送月度KPI
    sendMonth:function(){
      this.sendKPI(0);
    },   
    //发送季度KPI 
    sendJuDu:function(){
      this.sendKPI(1);
    },
    //发送计划KPI  pType:0月度  1季度
    sendKPI:function(pType){
        //获取操作周期
        
        
        this.month=new Date().getMonth();
            this.month=this.month+1;
        //获取上个季度数据
        if(pType==1){
            //季度时 选择当前季度
            if(this.month>=1&&this.month<=3){
                this.month='Q4';
            }
            else if(this.month>=4&&this.month<=6){
                this.month='Q1';
            }
            else if(this.month>=7&&this.month<=9){
                this.month='Q2';
            }
            else{
                this.month='Q3';
            }
        }
        else
        {
            if(this.month=1){
                this.month=12;
            }
        }
        SendFrameResult(this.deptModel.value,pType,this.month,this.year,this.currentUser.UserCode,this.currentUser.UserId,1).then(res=>{
            
            if(res.Result==1){
                this.$confirm( 
                '提示', 
                { 
                    title: '发送成功', 
                    message: '发送成功', 
                    showCancelButton: true, 
                    confirmButtonText: '确定', 
                    // cancelButtonText: '取消', 
                    type: 'warning'
                } ).then(() => {
                    //根据部门获取KPI列表
                    this.getFrameKpiList();
                    //判断当前是否已经发送
                    this.MyUserKpi();
                }).catch(() => {
                    //根据部门获取KPI列表
                    this.getFrameKpiList();
                    //判断当前是否已经发送
                    this.MyUserKpi();     
                });
                // //根据部门获取KPI列表
                // this.getFrameKpiList();
                // //判断当前是否已经发送
                // this.MyUserKpi();
            }
            else{
                 this.$message.error(res.Message);
            }
        });
    },
  }
}
</script>

<style lang="less" scoped>
.show{
  display: block;
}
.hidden{
  display: none;;
}
</style>
